import filter from 'lodash/filter';
import React from 'react';
import PropTypes from 'prop-types';
// MP - 9/17/19: for a reason that I cannot figure out, I had to direct import this path as opposed to using @spothero/ui/select to allow
// code splitting of this component. It makes absolutely no sense but this is the only thing that worked in trying to split it
// and it took an incredibly long time to figure that out. It works perfectly fine in all other components except the filters nested
// in SpotListFilters. Even renaming the file in node_modules to /[something-else] worked, as if it just didnt like the word lowercase "select" in the import.
// There is no rhyme or reason to it, unfortunately, that I could figure out. :(
import Select from '@spothero/ui/lib/Select/Select';

const getSelectItems = reservationTypes => {
    const activeItems = filter(reservationTypes, ({active, slug}) => {
        return active && slug !== 'all';
    });
    const items = activeItems.map(({name, slug}) => {
        return {
            label: name,
            value: slug,
        };
    });

    items.unshift({
        label: reservationTypes.all.name,
        value: reservationTypes.all.slug,
    });

    return items;
};

const AvailabilityFilters = ({
    activeReservationType,
    reservationTypes,
    onChange,
}) => {
    return (
        <div className="AvailabilityFilters">
            <p className="AvailabilityFilters-description">
                Filter spots by availability below.
            </p>
            <Select
                className="reservation-type-select"
                items={getSelectItems(reservationTypes)}
                defaultValue={activeReservationType}
                onChange={onChange}
            />
            {activeReservationType !== 'all' && (
                <p className="reservation-type-detail">
                    {reservationTypes[activeReservationType].description}
                </p>
            )}
        </div>
    );
};

AvailabilityFilters.propTypes = {
    activeReservationType: PropTypes.string.isRequired,
    reservationTypes: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default AvailabilityFilters;
